import { action as apiAction } from 'api/Api'
import {
  add as addDocumentFolderCreator
} from '../redux/elements'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  cardId: number
  name: string
  documentSourceId: number;
  path?: string;
  position?: number
}

const requestAddDocumentFolderCreator = (payload: Payload) => async dispatch => {
  const { cardId, name, documentSourceId, path, position } = payload

  const tempId = `temp-${new Date().getTime()}`

  const optimisticAction = optimisticDispatch(dispatch, addDocumentFolderCreator({
    cardId,
    element: {
      id: tempId,
      elementName: '/Data/DocumentsFolderCreator',
      name: name.trim(),
      documentSourceId,
      path,
      isBusy: true,
      index: position
    }
  }))

  try {
    await apiAction('AddDocumentsFolderCreator', {
      cardId,
      name: name.trim(),
      documentSourceId,
      path,
      position
    })
  } finally {
    optimisticAction.revert()
  }
}

export default requestAddDocumentFolderCreator